import { useState, useEffect, useMemo } from 'react';
import moment from 'moment';
import EventCard from '../EventCard/EventCard';
import { LoadingIcon } from '@prosolve/common-components-ui'
import useFetch from '../../hooks/useFetch';
import EventsCalendar from '../EventCalendar/EventsCalendar';
import { getClientSubdomain, getIsEventDelivered } from '../../utils';

const typeFilterCheck = (event, type, isStarSubdomain) => {
  const { endDate = '' } = event;
  if (type === 'Upcoming') {
    return moment(endDate).isSameOrAfter(moment().format('YYYY-MM-DD'));
  } else if (type === 'Past') {
    return moment(endDate).isBefore(moment().format('YYYY-MM-DD'));
  } else if (type === 'Open') {
    return !getIsEventDelivered(event, isStarSubdomain);
  } else if (type === 'Closed') {
    return getIsEventDelivered(event, isStarSubdomain);
  } else {
    return true;
  }
}

export default ({
  filters,
  displayFilters = {},
  onFilteredEventsChange = () => {},
  onEventsLoadingChange = () => {},
}) => {

  const [isLoading, setIsLoading] = useState(true)
  const [events, setEvents] = useState([])

  useEffect(() => {
    onEventsLoadingChange(isLoading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]) 

  const objectToQueryString = (obj) => {
    const objKeys = Object.keys(obj);
    return objKeys.length > 0 
      ? objKeys.map(key => key + '=' + obj[key]).join('&')
      : ''
  }

  const fetch = useFetch()

  const fetchEvents = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(`events?${objectToQueryString(filters)}`, { method: 'GET' })
      const jsonData = await response.json()
      if (jsonData.error) {
        setEvents([])
      } else {
        setEvents(jsonData)
      }
     setIsLoading(false)
    } catch (e) {
      console.log(e)
      setEvents([])
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchEvents()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters])

  const clientSubdomain = getClientSubdomain()

  const isStarSubdomain = (clientSubdomain === 'star')

  const isPastFilter = ['Past', 'Closed'].includes(displayFilters.type)
  const isCalendar = displayFilters.type === 'Calendar'

  const filteredEvents = useMemo(() => {
    return events.filter(
      (event) => {
        let passedFilters = true;

        const {
          type: typeFilter,
          account: accountFilter,
          // accountId: accountIdFilter,
          trainer: trainerFilter = '',
          csSpecialist: csSpecialistFilter = '',
          startDate: startDateFilter,
          endDate: endDateFilter
        } = displayFilters;

        const {
          // accountId,
          accountName,
          trainerNames = '',
          csSpecialist = '',
          startDate,
          endDate
        } = event;

        if (typeFilter && !typeFilterCheck(event, typeFilter, isStarSubdomain)) {
          passedFilters = false;
        }

        // if (accountIdFilter && accountIdFilter !== accountId) {
        //   passedFilters = false;
        // }

        if (accountFilter && !accountName.toLowerCase().includes(accountFilter.toLowerCase())) {
          passedFilters = false;
        }

        if (trainerFilter && !trainerNames.toLowerCase().includes(trainerFilter.toLowerCase())) {
          passedFilters = false;
        }

        if (csSpecialistFilter && !csSpecialist.toLowerCase().includes(csSpecialistFilter.toLowerCase())) {
          passedFilters = false;
        }

        if (startDateFilter && !moment(startDate).isSameOrAfter(moment(startDateFilter))) {
          passedFilters = false;
        }

        if (endDateFilter && !moment(endDate).isSameOrBefore(moment(endDateFilter))) {
          passedFilters = false;
        }

        return passedFilters;
      }
    ).sort(({ startDate: startDateA }, { startDate: startDateB }) => 
      moment(isPastFilter ? startDateB : startDateA, 'YYYY-MM-DD') - moment(isPastFilter ? startDateA : startDateB, 'YYYY-MM-DD')
    )
  }, [events, displayFilters, isPastFilter, isStarSubdomain])

  useEffect(() => {
    onFilteredEventsChange(filteredEvents)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredEvents])

  return (
    <div>
      {
        isLoading ?
          <div style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            height: '650px'
          }}>
            <div style={{ marginTop: '40px' }}>
              <LoadingIcon />
            </div>
          </div>
          :
          <div style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            rowGap: '20px',
            padding: '20px'
          }}>
            {
              isCalendar
              ?
              <EventsCalendar events={filteredEvents} />
              :
              filteredEvents.length > 0
              ?
              filteredEvents
              .map(event => <EventCard key={event.id} eventData={event} onReloadData={() => fetchEvents()} />)
              :
              <div style={{
                color: '#565656',
                fontSize: '14px',
              }}>
                {'No events found'}
              </div>
            }
          </div>
      }
    </div>
  )
}